import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { fetchBlog } from "@/lib/api";

const formatDate = (d) => {
    try {
        return new Date(d).toLocaleDateString(undefined, { day: "numeric", month: "long", year: "numeric" });
    } catch (e) {
        return "";
    }
};

const BlogDetail = () => {
    const { id } = useParams();
    const [post, setPost] = useState(null);
    const [loading, setLoading] = useState(true);
    const [err, setErr] = useState(null);

    useEffect(() => {
        let mounted = true;
        fetchBlog(id)
            .then((p) => mounted && setPost(p))
            .catch(() => mounted && setErr("Post not found."))
            .finally(() => mounted && setLoading(false));
        return () => {
            mounted = false;
        };
    }, [id]);

    return (
        <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 py-14">
            <Link to="/blogs" className="inline-flex items-center gap-1 text-sm text-maroon-700/80 hover:text-maroon-900">
                <ArrowLeft size={14} /> All blogs
            </Link>

            {loading && <p className="mt-8 text-maroon-700/70">Loading…</p>}
            {err && <p className="mt-8 text-maroon-700/70">{err}</p>}

            {post && (
                <article className="mt-6">
                    <div className="text-[11px] uppercase tracking-[0.22em] text-gold-500 font-semibold">
                        {formatDate(post.created_at)} · {post.author}
                    </div>
                    <h1 className="heading-display mt-2 text-pretty">{post.title}</h1>
                    <p className="mt-4 text-lg text-maroon-700/85 italic">{post.excerpt}</p>
                    <div className="gold-divider my-6 opacity-60" />
                    <div className="prose prose-maroon max-w-none text-maroon-800/95 leading-relaxed whitespace-pre-wrap font-sans">
                        {post.body}
                    </div>
                </article>
            )}
        </div>
    );
};

export default BlogDetail;
